import store from '../../store/index'
export default {
    track(option){

        let title = option.title || '';
        let content = option.content || {};
        let source = store.state.source;
        if(source == 'douyin'){
            content['来源'] = '抖音'
        }else if(source == 'wechat'){
            content['来源'] = '公众号'
        }else if(source == 'share'){
            content['来源'] = '链接分享'
        }else{
            content['来源'] = source
        }
        
        zhuge.track(title,content); 
       
    }
}
